import { ComponentStyleConfig } from '@chakra-ui/react';
import { getColorVar, StyleFunctionProps } from '@chakra-ui/theme-tools';
import { textStyles } from '../../common';

export const InputStyles: ComponentStyleConfig = {
  baseStyle: (props: StyleFunctionProps) => {
    return {
      field: {
        backgroundColor: 'field',
        borderRadius: '8px',
        outline: '2px solid transparent',
        '&&&': {
          boxShadow: 'none',
          borderColor: 'border.layer.0',
        },
        _hover: {
          backgroundColor: `color-mix(in srgb, ${getColorVar(props.theme, 'field')} 90%, ${getColorVar(props.theme, 'gray.400')} 10%)`,
          '&&': {
            borderColor: 'border.1',
          },
        },
        _focusVisible: {
          outlineColor: 'state.selected',
        },
        _active: {
          backgroundColor: 'field.active',
          '&&': {
            borderColor: 'state.selected',
          },
        },
        _invalid: {
          '&&&': {
            borderColor: 'state.error',
          },
        },
        _disabled: {
          opacity: 1,
          color: 'text.disabled',
          '&&&': {
            borderColor: 'border.1',
          },
        },
        _readOnly: {
          backgroundColor: 'layer.0',
          cursor: props.cursor ?? 'not-allowed',
          '&&&': {
            borderColor: 'border.layer.0',
          },
        },
      },
      addon: {
        border: 'solid 1px',
        borderColor: 'border.1',
      },
    };
  },
  defaultProps: {
    errorBorderColor: 'red.500',
  },
  sizes: {
    xs: {
      field: {
        ...textStyles['body-sm'],
        px: 2, // 8px
        py: 1, // 4px
        height: '24px',
      },
      addon: {
        ...textStyles['body-sm'],
        height: '24px',
      },
    },
    sm: {
      field: {
        ...textStyles['body-sm'],
        px: 2, // 8px
        py: 1.5, // 6px
        height: '28px',
      },
      addon: {
        ...textStyles['body-sm'],
        px: 2, // 8px
        py: 1.5, // 6px
        height: '28px',
      },
    },
    md: {
      field: {
        ...textStyles['body-md'],
        px: 2, // 8px
        py: 1.5, // 6px
        height: '32px',
      },
      addon: {
        ...textStyles['body-md'],
        px: 2, // 8px
        py: 1.5, // 6px
        height: '32px',
      },
    },
    lg: {
      field: {
        ...textStyles['body-md'],
        px: 3, // 12px
        py: 2.5, // 10px
        height: '40px',
      },
      addon: {
        ...textStyles['body-md'],
        px: 3, // 12px
        py: 2.5, // 10px
        height: '40px',
      },
    },
  },
};
